module.exports = __webpack_public_path__ + "img/creationPortage.618cacb8.png";